<template>
	<div>
	  <header
	    :class="bannerType"
	  >
	  <a-carousel :style="{
      'height':(height||320)+'px'
    }"  autoplay>
	      <div v-for="(item,index) in img_banner" :key="index" :style="{
      'height':(height||320)+'px'
    }">
			  <img :src="item.url_img_full" alt="" style="width: 100%;height:100%;object-fit:cover;">
		  </div>
	  </a-carousel>
	    <div class="top" :style="topColor">
	      <div>
	        <div>
	          <img src="../../assets/images/index/WL-logo.png" alt="" />
	          四川省文学艺术界联合会｜专家评审平台
	        </div>
	        <ul>
	          <li
	            :class="activeNav === nav_item.name ? 'nav activeNav' : 'nav'"
	            v-for="(nav_item, nav_index) in navList"
	            :key="nav_index"
	            @click="changeActive(nav_item.url,nav_item.url_status)"
	          >
	            {{ nav_item.name }}
	          </li>
	        </ul>
	        <div v-if="userName == ''" @click="toLogin">登陆/注册</div>
	        <div
	          v-else-if="userName !== null"
	          :class="userActive === true ? 'activeNav' : ''"
	          @click="toUser"
	        >
	          {{ userName }}
	        </div>
	        <div
	          v-else
	          :class="userActive === true ? 'activeNav' : ''"
	          @click="toUser"
	        >
	          个人中心
	        </div>
	      </div>
	    </div>
	  </header>
	</div>
</template>

<script>
import Storage from "../../xx-vue/utils/storage";
import {getBannerList,getNavigationList} from "../../xx-vue/services/banner";
export default {
  props: {
    activeNav: {
      type: String,
    },
    //.top背景色
    topColor: {
      type: String,
    },
    //背景类名
    bannerType: {
      type: String,
    },
    //是否激活用户
    userActive: {
      type: Boolean,
      default: false,
    },
    //banner高度
    height: {
      type: Number,
    },
	
  },
  data() {
    return {
      //导航列表
      // navList: [
      //   // { name: "首页", url: "/" },
      //   // { name: "艺讯", url: "/art_info" },
      //   // { name: "比赛评选", url: "/match" },
      //   // { name: "评审专家库", url: "/expert" },
      //   // { name: "数字艺术馆", url: "http://sz.scwyy.cn/home/index.html" },
      //   // { name: "联系我们", url: "/contactUs" },
      // ],
	  navList: [],
	  img_banner: {},
      //用户名
      userName: "",
      screenWidth: document.body.clientWidth, //屏幕宽度
    };
  },

  mounted() {
    const userInfo = Storage.getStorage("info");
    if (userInfo !== undefined) {
      this.userName = userInfo.name;
    }
	this.getNavigationData();
	this.getBannerData();
  },

  methods: {
	//获取轮播数据
	getBannerData(){
		getBannerList().then((api_res)=>{
			this.img_banner = api_res.data.data_list;
		})
	},
	//获取导航栏数据
	getNavigationData(){
		getNavigationList().then((api_res)=>{
			this.navList = api_res.data.data;
		})
	},
    //跳转登录
    toLogin() {
      this.$router.push("/login");
    },
    //nav跳转
    changeActive(path,type) {
      if (type !== 1) {
        this.$router.push(path);
      } else {  
        window.open(path);
      }
    },
    //跳转个人中心
    toUser() {
      this.$router.push("/user");
    },
  },
};
</script>
<style scoped>
	.ant-carousel >>> .slick-slide {
	  text-align: center;
	  height: 100%;
	  background: #364d79;
	  overflow: hidden;
	}
	.ant-carousel >>> .slick-slide h3 {
	  color: #fff;
	}
</style>
<style lang="less" scoped>
	
.header {
  width: 100%;
  .top {
    padding: 26px 0;
    background-color: rgba(0, 0, 0, 0.3);

    width: 100%;
    color: #ffffff;
    position: fixed;
    box-sizing: border-box;
    z-index: 99;
    top: 0;

    & > div {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      & > :first-child {
        font-size: 14px;
        display: flex;
        align-items: center;
        user-select: none;
        margin-right: 10%;

        img {
          width: 38px;
          height: 38px;
          margin-right: 4px;
        }
      }

      & > :last-child {
        cursor: pointer;
      }

      .nav {
        font-weight: bold;
      }

      li {
        cursor: pointer;
        margin-right: 40px;
      }

      ul {
        display: flex;
      }

      .activeNav {
        color: #f2252f;
        position: relative;

        &::before {
          content: "";
          display: block;
          width: 1px;
          height: 16px;
          background-color: #f2252f;
          position: absolute;
          top: -18px;
          left: 48%;
        }

        &::after {
          content: "";
          display: block;
          width: 1px;
          height: 16px;
          background-color: #f2252f;
          position: absolute;
          bottom: -18px;
          left: 48%;
        }
      }
    }
  }

  .title {
    display: flex;
    justify-content: center;
    padding-top: 120px;
    margin-bottom: 40px;
    height: 100%;

    img {
      width: 800px;
      height: 310px;
    }
  }
}

</style>
